module.exports = __webpack_public_path__ + "img/hr.f98c8989.svg";